import React from "react"
import styled from "styled-components"

const Message = styled.div`
  font-size: 0.9rem;
  background: ${props => props.theme.styles.grey};
  color: ${props => props.theme.styles.white};
  padding: 20px;
  margin: 0 0 45px 0;

  p {
    color: ${props => props.theme.styles.offwhite};
    margin-bottom: 10px;
  }
  p:last-child {
    margin: 0;
  }
  a {
    color: white;
    text-decoration: underline;
  }
`

export default ({ children }) => <Message>{children}</Message>
